<div id="container" class="absolute inset-0 flex z-10">
  <div id="layout" class="w-full h-full flex flex-col">
    <div
      id="{id}"
      style="background-image: url({!$playerOpen ? posterImage : ''})"
      class="story w-full h-full bg-black {config.position ? positionProps[config.position] : 'mx-auto'} bg-cover bg-opacity-50 overflow-hidden flex-0 relative">
      {#if autoplay || $playerOpen}
        <amp-story-player
          id="{id}"
          class="w-full h-full"
          amp-cache="cdn.ampproject.org"></amp-story-player>
      {:else}
        <Autoplay title="{title}" />
      {/if}
    </div>
  </div>
</div>

<script>
  import { onMount, tick, onDestroy } from 'svelte'
  import Autoplay from '~/components/Autoplay.svelte'

  import { get, isEmpty } from 'lodash-es'

  import { playerOpen, fetchStory } from '~/store/index.js'

  export let story, hrefs, config, id, stories_

  let playerEl, player, title, posterImage

  const AmpStoryPlayer = window.AmpStoryPlayer

  function getStoryURL(story, id) {
    // append id if reload requires to forget page history... ?story&id=${id}
    return `${story.url}?story&id=${id}`
  }

  const positionProps = {
    left: 'mr-auto',
    right: 'ml-auto',
  }

  const autoplay = !(
    config.autoplay === 'false' ||
    config.autoplay === false ||
    !config.autoplay
  )

  async function createAMPInstance(id) {
    const firstStory = story

    posterImage = get(firstStory, 'poster.story')
    title = get(firstStory, 'title')
    playerEl = document.querySelector('amp-story-player')
    player = new AmpStoryPlayer(window, playerEl)
    player.load()

    if (hrefs.length) {
      const promises = []

      hrefs.forEach((url) => {
        const href = new URL(url)
        console.log({ href })
        promises.push(
          fetchStory(href.pathname, config.workspace).then((val) => val[0])
        )
      })
      stories_ = await Promise.all(promises)
    }

    if (autoplay || $playerOpen) {
      let callback
      if (!isEmpty(stories_)) {
        callback = stories_.map((story) => ({
          href: getStoryURL(story, id),
          title: story.title,
        }))
      } else
        callback = [
          {
            href: getStoryURL(story, id),
            title: story.title,
          },
        ]

      player.add(callback)
      if (stories_.length) return showActiveStory(0)
      else player.show(getStoryURL(story, id))
    }
  }

  function showActiveStory(index) {
    const selected = stories_[index]
    const storyURL = getStoryURL(selected, id)
    title = selected.title
    player.show(storyURL)
  }

  const unsubscribe = playerOpen.subscribe(async (value) => {
    if (value === true) {
      await tick()
      createAMPInstance(id)
    }
  })

  onMount(async () => {
    await tick()
    createAMPInstance(id) // Create first story instance
  })

  onDestroy(unsubscribe)
</script>
